import React, { Component } from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

import TimeEntryCreateEditFormWithDateEnhanced from './TimeEntryCreateEditFormWithDateEnhanced';


const propTypes = exact({
  timeEntryId: PropTypes.number,
  timeEntryKey: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
  dispatchInitFormData: PropTypes.func.isRequired,
  dispatchCreateOrUpdateTimeEntry: PropTypes.func.isRequired,

  supervisorId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  originDate: PropTypes.string.isRequired,
  minEditDate: PropTypes.string.isRequired,
  maxEditDate: PropTypes.string.isRequired,

  timeEntry: PropTypes.object,
});


class TimeEntryCreateEditFormWithDateWrapper extends Component {
  componentDidMount() {
    const { dispatchInitFormData, timeEntry } = this.props;
    dispatchInitFormData(timeEntry);
  }

  render() {
    const {
      onSuccess,
      supervisorId,
      userId,
      originDate,
      timeEntryId,
      timeEntryKey,
      dispatchCreateOrUpdateTimeEntry,
      minEditDate,
      maxEditDate,
    } = this.props;

    const submit = (values) => {
      dispatchCreateOrUpdateTimeEntry(
        onSuccess,
        timeEntryId,
        timeEntryKey,
        values,
        supervisorId,
        userId,
        originDate,
      );
    };

    return (
      <div>
        <TimeEntryCreateEditFormWithDateEnhanced
          onSubmit={submit}
          isNewRecord={!timeEntryId}
          minEditDate={minEditDate}
          maxEditDate={maxEditDate}
        />
      </div>
    );
  }
}

TimeEntryCreateEditFormWithDateWrapper.propTypes = propTypes;

export default TimeEntryCreateEditFormWithDateWrapper;
